var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuCvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.875 6.75H26.125V13.2083H13.2083V26.125H6.75V64.875H13.2083V77.7917H26.125V84.25H64.875V77.7917H77.7917V64.875H84.25V26.125H77.7917V13.2083H64.875V6.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 58.4167H32.5833V64.875H26.125V58.4167Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.875 58.4167H58.4167V64.875H64.875V58.4167Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 26.125H32.5833V32.5834H26.125V26.125Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.875 26.125H58.4167V32.5834H64.875V26.125Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5833 32.5834H39.0417V39.0417H32.5833V32.5834Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4167 32.5834H51.9583V39.0417H58.4167V32.5834Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 32.5834H26.125V39.0417H19.6667V32.5834Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3333 32.5834H64.875V39.0417H71.3333V32.5834Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 84.25V90.7083H64.875V84.25H26.125Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4167 71.3334V64.875H32.5833V71.3334H58.4167Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2083 77.7917V84.25H26.125V77.7917H13.2083Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2083 64.875H6.75V77.7917H13.2083V64.875Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.291664 64.875H6.75V26.125H0.291664V64.875Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 26.125H13.2083V13.2084H6.75L6.75 26.125Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2083 6.75002V13.2084H26.125V6.75002H13.2083Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 0.291687V6.75002H64.875V0.291687H26.125Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7917 13.2084V6.75002H64.875V13.2084H77.7917Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7917 26.125H84.25V13.2084H77.7917V26.125Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.25 64.875H90.7083V26.125H84.25V64.875Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.25 64.875H77.7917V77.7917H84.25V64.875Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7917 84.25V77.7917H64.875V84.25H77.7917Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCvIcon);
export default __webpack_public_path__ + "static/media/menu_cv_icon.fd1699dd74fa4646db1073f72c8cb756.svg";
export { ForwardRef as ReactComponent };